var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailNew = function SvgMailNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M13.783.916H4.216a3.55 3.55 0 0 0-3.55 3.55v7.067a3.55 3.55 0 0 0 3.55 3.55h9.567a3.55 3.55 0 0 0 3.55-3.55V4.466a3.55 3.55 0 0 0-3.55-3.55",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M9 8.833a2.87 2.87 0 0 1-1.817-.658L4.349 5.833a.635.635 0 0 1 .834-.958l2.816 2.341a1.59 1.59 0 0 0 2.05 0l2.742-2.325a.617.617 0 0 1 .833.067.634.634 0 0 1-.067.883l-2.741 2.325a2.83 2.83 0 0 1-1.817.667"
  })));
};
export default SvgMailNew;